import React from 'react';
import '../../filterablePeripheralList/peripheralList/peripheralRow/peripheralRow.css'

class PWMRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inst: this.props.chanInst[this.props.index]
        };
        this.handleInstChange = this.handleInstChange.bind(this);
        this.getDefault = this.getDefault.bind(this);
    }

    getDefault() {
        // Select First non-used Channel
        const vals = "ABCDEFGH";
        let occurances = Array(vals.length).fill(0);
        this.props.chanInst.forEach((inst, idx) => {
            if (inst !== '' && idx !== this.props.index) {
                occurances[inst.charCodeAt(0) - 'A'.charCodeAt(0)] = 1;
            }
        })
        let new_inst = vals[occurances.indexOf(0)];
        this.setState({inst: new_inst});
        this.props.chanInst[this.props.index] = new_inst;
        return new_inst;
    }

    handleInstChange(evt) {
        let selected_val = evt.target.value;
        this.setState({inst: selected_val});
        this.props.chanInst[this.props.index] = selected_val;
    }

    render() {

        let pinNameStyle = {
            display: "block",
            fontSize: "0.8em",
            width: "3em",
        }

        let dropdownStyle = {
            marginLeft: "1em",
            fontSize: "0.8em",
            width: "3em",
        }

        return (
            <tr>
                <td>
                    <div className="row-peripheral">
                        <span style={pinNameStyle}>
                            {this.props.name.toUpperCase() + this.props.pinName}
                        </span>

                        <select id="pwm_id" 
                                style={dropdownStyle} 
                                onChange={this.handleInstChange} 
                                value={this.state.inst !== '' ? this.state.inst : this.getDefault()}>
                            <optgroup label="Instance">
                                <option value="A">A</option>
                                <option value="B">B</option>
                                <option value="C">C</option>
                                <option value="D">D</option>
                                <option value="E">E</option>
                                <option value="F">F</option>
                                <option value="G">G</option>
                                <option value="H">H</option>
                            </optgroup>
                        </select>
                    </div>
                </td>
            </tr>
        );
    }
}

export default PWMRow;
